<script>
  import { onMount } from "svelte";
  import { DateTime } from "luxon";

  export let emptyLeg;
  let dateTimeFormatted = "";
  let gmtOffset = "";

  onMount(() => {
    //    gmtOffset = emptyLeg.datetime.toFormat("Z");
    //   dateTimeFormatted = emptyLeg.datetime.toFormat("ccc, LLL d, y; HH:mm a");
    dateTimeFormatted = emptyLeg.datetimelocal.toFormat("ccc, LLL d, y; HH:mm a");
  });
</script>

<div class="leg">
  <div class="when">
    {dateTimeFormatted}
    <span class="gmt">GMT{emptyLeg.gmtoffset}</span>
    {#if emptyLeg.highlight}
      <img src="assets/like.svg" alt="" />
    {/if}
  </div>

  <div class="airport">
    <img src="assets/airport-departure.svg" alt="" />
    {emptyLeg.fromairport.gps_code}
    <span class="name">{emptyLeg.fromairport.name}</span>
  </div>

  <div class="airport">
    <img src="assets/airport-arrival.svg" alt="" />
    {emptyLeg.toairport.gps_code}
    <span class="name">{emptyLeg.toairport.name}</span>
  </div>

  {#if emptyLeg.cass == 1 || emptyLeg.kcm == 1}
    <div class="requires">
      REQUIRES
      {#if emptyLeg.cass == 1}CASS{/if}
      {#if emptyLeg.kcm == 1}KCM{/if}
    </div>
  {/if}
</div>

<style>
  .leg {
    font-size: 10pt;
  }
  .leg .when {
    color: #000;
  }
  .leg .when .gmt {
    font-size: 0.8em;
  }
  .leg .when img {
    margin-left: 5px;
  }
  .leg img {
    vertical-align: text-bottom;
  }
  .leg .airport img {
    margin-right: 5px;
  }
  .leg .airport .name {
    font-size: 0.8em;
  }
  .leg .requires {
    font-size: 8pt;
    margin-top: 4px;
  }
</style>
